import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { baseReducer } from '../select/reducer.js';
import { setGroups, clearSelectedAndCloseMenu, closeMenu, openMenu } from '../select/actions.js';
import { getDefaultCursorIndex, getOptionValue } from '../select/selectors.js';
import { getGroups, isEmpty } from './selectors.js';
import { setSelectedValue, setHideSelected, removeSelectedOption, removeSelectedIndex, addSelectedIndex } from './actions.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
function getInitialState(groups) {
  var defaultSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var hideSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    groups: groups,
    menuIsOpen: false,
    selected: defaultSelected,
    searchString: '',
    filteredGroups: null,
    cursorIndex: getDefaultCursorIndex(groups),
    hideSelected: hideSelected,
    groupsWithoutSelected: groups
  };
} // eslint-disable-next-line complexity

function multiselectReducer(state, action) {
  switch (action.type) {
    case openMenu.type:
      return _objectSpread(_objectSpread({}, state), handleOpenMenu(state));

    case closeMenu.type:
      return _objectSpread(_objectSpread({}, state), handleCloseMenu(state));

    case addSelectedIndex.type:
      return addDefaultCursorPosFromNewState(_objectSpread(_objectSpread({}, state), addSelectedByIndex(state, action.index)));

    case removeSelectedIndex.type:
      return addDefaultCursorPosFromNewState(_objectSpread(_objectSpread({}, state), removeSelectedByIndex(state, action.index)));

    case removeSelectedOption.type:
      return addDefaultCursorPosFromNewState(_objectSpread(_objectSpread({}, state), removeSelected(state, action.unselectedOption)));

    case setHideSelected.type:
      return addDefaultCursorPosFromNewState(_objectSpread(_objectSpread({}, state), handleToggleHideSelected(state, action.hideSelected)));

    case clearSelectedAndCloseMenu.type:
      return _objectSpread(_objectSpread(_objectSpread({}, state), clearSelection(state)), {}, {
        groupsWithoutSelected: state.groups
      });

    case setGroups.type:
      return _objectSpread({}, getInitialState(action.groups, state.selected, state.hideSelected));

    case setSelectedValue.type:
      return addDefaultCursorPosFromNewState(_objectSpread(_objectSpread({}, state), setSelectedControllable(state, action.selected)));

    default:
      return baseReducer(state, action, {
        getGroups: getGroups,
        isEmpty: isEmpty
      });
  }
}

function handleOpenMenu(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    menuIsOpen: true
  });
}

function handleCloseMenu(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    menuIsOpen: false
  });
}

function clearSelection(state) {
  var groups = getGroups(state);
  return {
    selected: null,
    cursorIndex: getDefaultCursorIndex(groups),
    menuIsOpen: false
  };
}

function addSelectedByIndex(state, index) {
  var _context;

  var groups = getGroups(state);

  var _index = _slicedToArray(index, 2),
      grpIndex = _index[0],
      optIndex = _index[1];

  var selectedOption = groups[grpIndex].options[optIndex];
  var newSelected = !state.selected ? [selectedOption] : _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(state.selected), [selectedOption]);
  return {
    selected: newSelected,
    menuIsOpen: false,
    searchString: '',
    groupsWithoutSelected: filterSelected(state.groups, newSelected)
  };
}

function removeSelectedByIndex(state, index) {
  var groups = getGroups(state);

  var _index2 = _slicedToArray(index, 2),
      grpIndex = _index2[0],
      optIndex = _index2[1];

  var unselectedOption = groups[grpIndex].options[optIndex];
  return removeSelected(state, unselectedOption);
}

function removeSelected(state, option) {
  var _context2;

  var selectedWithoutOne = _filterInstanceProperty(_context2 = state.selected).call(_context2, function (o) {
    return getOptionValue(o) !== getOptionValue(option);
  });

  return {
    selected: selectedWithoutOne,
    menuIsOpen: false,
    searchString: '',
    groupsWithoutSelected: filterSelected(state.groups, selectedWithoutOne)
  };
}

function handleToggleHideSelected(state, hideSelected) {
  var result = {
    hideSelected: hideSelected
  };

  if (hideSelected) {
    result.groupsWithoutSelected = filterSelected(state.groups, state.selected);
  }

  return result;
}

function filterSelected(groups, selected) {
  var selectedValues = {};

  if (selected) {
    _forEachInstanceProperty(selected).call(selected, function (s) {
      selectedValues[getOptionValue(s)] = true;
    });
  }

  return _mapInstanceProperty(groups).call(groups, function (g) {
    var newOptions = [];

    if (g.options) {
      var _context3;

      newOptions = _filterInstanceProperty(_context3 = g.options).call(_context3, function (opt) {
        return !selectedValues[getOptionValue(opt)];
      });
    }

    return _objectSpread(_objectSpread({}, g), {}, {
      options: newOptions
    });
  });
}

function setSelectedControllable(state, selected) {
  var result = {
    selected: selected
  };

  if (state.hideSelected) {
    result.groupsWithoutSelected = filterSelected(state.groups, selected);
  }

  return result;
}

function addDefaultCursorPosFromNewState(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    cursorIndex: getDefaultCursorIndex(getGroups(state))
  });
}

export { getInitialState, multiselectReducer };
